import { AwsUtil } from './../../../authentication/aws.service';
import { SuspenseBalanceMetric } from './../suspense-balance-metric';
import { Component, OnInit, ViewEncapsulation, AfterViewInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { SurvivalHorizonService } from '../../../survival-horizon/survival-horizon.service';

interface SuspenseBalanceDetail {
    externalID: string;
    currency: string;
    direction: string;
    account: string;
    tradeDatetime: string;
    client: string;
    amount: number;
    flowKey: string;
    eventDatetime: string;
    type: string;
}

@Component({
    selector: 'app-suspense-balance-details',
    templateUrl: './suspense-balance-details.component.html',
    styleUrls: ['./suspense-balance-details.component.css'],
    encapsulation: ViewEncapsulation.None
})

export class SuspenseBalanceDetailsComponent implements OnInit, AfterViewInit, OnDestroy {

    fullTransaction: string;
    suspenseBalanceMetric: SuspenseBalanceMetric;
    dataStreamDisposable: Subscription;
    survivalHorizonService: SurvivalHorizonService;

    suspenseBalanceDetails: SuspenseBalanceDetail[];

    tableDataTop10: SuspenseBalanceDetail[] = [];
    tableDataLast10: SuspenseBalanceDetail[] = [];
    currency: string;
    showTable = false;
    constructor(private awsUtil: AwsUtil) {}

    ngOnInit() {
    }

    ngAfterViewInit() {
        // this.suspenseBalanceMetric.breakDownLast10 = [];
        this.tableDataTop10.push(
            {currency: 'USD', account: 'ACCOUNT1', tradeDatetime: '01-01-2018', client: 'Client1', direction: 'REC',
            amount: 1000000, externalID: '12345', flowKey: '12345', eventDatetime: '01-01-2018', type: 'top10'});
        this.tableDataTop10.push(
            {currency: 'USD', account: 'ACCOUNT1', tradeDatetime: '01-01-2018', client: 'Client1', direction: 'REC',
            amount: 1000000, externalID: '12345', flowKey: '12345', eventDatetime: '01-01-2018', type: 'top10'});
        this.tableDataTop10.push(
            {currency: 'USD', account: 'ACCOUNT1', tradeDatetime: '01-01-2018', client: 'Client1', direction: 'REC',
            amount: 1000000, externalID: '12345', flowKey: '12345', eventDatetime: '01-01-2018', type: 'top10'});
        this.tableDataTop10.push(
            {currency: 'USD', account: 'ACCOUNT1', tradeDatetime: '01-01-2018', client: 'Client1', direction: 'REC',
            amount: 1000000, externalID: '12345', flowKey: '12345', eventDatetime: '01-01-2018', type: 'top10'});
        this.tableDataTop10.push(
            {currency: 'USD', account: 'ACCOUNT1', tradeDatetime: '01-01-2018', client: 'Client1', direction: 'REC',
            amount: 1000000, externalID: '12345', flowKey: '12345', eventDatetime: '01-01-2018', type: 'top10'});

        this.tableDataLast10 = [];
        this.tableDataLast10.push(
            {currency: 'USD', account: 'ACCOUNT1', tradeDatetime: '01-01-2018', client: 'Client1', direction: 'REC',
            amount: 1000000, externalID: '12345', flowKey: '12345', eventDatetime: '01-01-2018', type: 'last10'});
        this.tableDataLast10.push(
            {currency: 'USD', account: 'ACCOUNT1', tradeDatetime: '01-01-2018', client: 'Client1', direction: 'REC',
            amount: 1000000, externalID: '12345', flowKey: '12345', eventDatetime: '01-01-2018', type: 'last10'});
        this.tableDataLast10.push(
            {currency: 'USD', account: 'ACCOUNT1', tradeDatetime: '01-01-2018', client: 'Client1', direction: 'REC',
            amount: 1000000, externalID: '12345', flowKey: '12345', eventDatetime: '01-01-2018', type: 'last10'});
        this.tableDataLast10.push(
            {currency: 'USD', account: 'ACCOUNT1', tradeDatetime: '01-01-2018', client: 'Client1', direction: 'REC',
            amount: 1000000, externalID: '12345', flowKey: '12345', eventDatetime: '01-01-2018', type: 'last10'});
        this.tableDataLast10.push(
            {currency: 'USD', account: 'ACCOUNT1', tradeDatetime: '01-01-2018', client: 'Client1', direction: 'REC',
            amount: 1000000, externalID: '12345', flowKey: '12345', eventDatetime: '01-01-2018', type: 'last10'});

        /*
        this.dataStreamDisposable = this.survivalHorizonService.getPollingDataSubject()
            .subscribe({next: (data: GetSurvivalHorizonServiceDataOutput) => {
                if (data.suspenseBalanceDetails) {
                    this.suspenseBalanceDetails = data.suspenseBalanceDetails;
                    this.tableDataTop10 = this.suspenseBalanceDetails.filter((suspenseBalanceDetailRow) => {
                        return suspenseBalanceDetailRow.type === 'top10';
                    });
                    this.tableDataLast10 = this.suspenseBalanceDetails.filter((suspenseBalanceDetailRow) => {
                        return suspenseBalanceDetailRow.type === 'last10';
                    });
                }
                setTimeout(() => {
                    this.showMetric();
                })
            }, (err) => {
                console.log(err);
                throw err;
            });
        */
       setTimeout(() => {
        this.showMetric();
    })
}

    ngOnDestroy() {
        if (this.dataStreamDisposable) {
            this.dataStreamDisposable.unsubscribe();
        }
    }

    showMetric() {
        if (this.tableDataTop10.length > 0) {
            this.showTable = true;
        } else {
            this.showTable = false;
        }
    }
    /*
    showTransaction(event: any, transaction: Transaction, overlayPanel: OverlayPanel) {
        const request = {
            currency: this.suspenseBalanceMetric.breakDown['currency'],
            eventDatetime: transaction.eventDatetime,
            flowKey: transaction.flowKey
        } as GetFullTransactionRequest;
        this.awsUtil.webAPICall(WebApiEndpoints.QueryFullTransaction, request)
            .then((result: GetFullTransactionResult) => {
                this.fullTransaction = JSON.stringify(result, null, 2);
                overlayPanel.toggle(event);
            })
    } */
}
